import { Fragment, PropsWithChildren, useContext } from "react";
import { SessionContext } from "../../utility/useSession";
import TwoFactorRegistration from "./twoFactorRegistration";

const TwoFactor = (props: PropsWithChildren) => {
    const session = useContext(SessionContext);

    if (session.current.credential) {
        if (session.current.site) {
            if (session.current.site.preferences.two_factor_required == true) {
                if (session.current.credential.twoFactorEnabled != true) {
                    return <TwoFactorRegistration onClose={() => {
                        session.logout();
                    }} show={true} />
                }
            }
        }
    }
    return <Fragment>{props.children}</Fragment>
}

export default TwoFactor;